import { render, staticRenderFns } from "./BmiCalculator.vue?vue&type=template&id=7abc676e&scoped=true&"
import script from "./BmiCalculator.vue?vue&type=script&lang=js&"
export * from "./BmiCalculator.vue?vue&type=script&lang=js&"
import style0 from "./BmiCalculator.vue?vue&type=style&index=0&id=7abc676e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abc676e",
  null
  
)

export default component.exports